// Affirm Product Update Handler
// This file handles updating Affirm promotional messaging when product variants change

document.addEventListener('DOMContentLoaded', function() {
  let updateTimeout;
  
  // Function to update Affirm with new price
  function updateAffirmPrice() {
    // Clear any existing timeout
    if (updateTimeout) {
      clearTimeout(updateTimeout);
    }
    
    // Wait for DOM to be fully updated
    updateTimeout = setTimeout(function() {
      // Find the Affirm element
      const affirmElement = document.querySelector('.affirm-as-low-as');
      
      if (!affirmElement) {
        console.log('Affirm element not found');
        return;
      }

      // Try multiple selectors to find the current price
      let priceElement = document.querySelector('.price-item--regular') || 
                        document.querySelector('.price-item--sale') ||
                        document.querySelector('.price__regular .price-item') ||
                        document.querySelector('.price__sale .price-item') ||
                        document.querySelector('.price__container .price-item');

      if (!priceElement) {
        console.log('Price element not found');
        return;
      }

      // Get the text content and extract numeric price
      const priceText = priceElement.textContent.trim();
      const extractedPrice = priceText.replace(/[^0-9]/g, '');

      if (!isNaN(extractedPrice) && extractedPrice.length > 0) {
        // Update the data-amount attribute
        affirmElement.setAttribute('data-amount', parseInt(extractedPrice, 10));
        
        // Refresh Affirm UI
        if (typeof affirm !== 'undefined' && affirm.ui && typeof affirm.ui.refresh === 'function') {
          affirm.ui.ready(function() {
            affirm.ui.refresh();
          });
        } else {
          console.log('Affirm not loaded yet, will retry...');
          // Retry after a short delay if Affirm isn't loaded
          setTimeout(function() {
            if (typeof affirm !== 'undefined' && affirm.ui && typeof affirm.ui.refresh === 'function') {
              affirm.ui.ready(function() {
                affirm.ui.refresh();
              });
            }
          }, 500);
        }
      } else {
        console.log('Could not extract valid price from:', priceText);
      }
    }, 500); // Increased delay to ensure DOM is updated
  }

  // Listen for variant changes via radio buttons
  const radioInputs = document.querySelectorAll('.product-form__input input[type=radio]');
  radioInputs.forEach(radioInput => {
    radioInput.addEventListener('change', function(event) {
      if (radioInput.checked) {
        updateAffirmPrice();
      }
    });
  });

  // Listen for variant changes via dropdowns
  const variantSelects = document.querySelectorAll('select[name*="option"], .product-form__input select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      updateAffirmPrice();
    });
  });

  // Listen for the specific event that product-info.js triggers when variants change
  document.addEventListener('product-info:loaded', function() {
    // This event is triggered when product-info is loaded
    console.log('Product info loaded, setting up Affirm listeners');
  });

  // Listen for any changes to the product form using MutationObserver
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Check if price elements were updated
          const priceElements = document.querySelectorAll('.price-item--regular, .price-item--sale');
          if (priceElements.length > 0) {
            shouldUpdate = true;
          }
        }
      });
      
      if (shouldUpdate) {
        updateAffirmPrice();
      }
    });

    observer.observe(productForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-amount']
    });
  }

  // Listen for custom events that might be triggered by other scripts
  document.addEventListener('variant:change', function(event) {
    updateAffirmPrice();
  });

  document.addEventListener('price:update', function(event) {
    updateAffirmPrice();
  });

  // Listen for the specific price update event that product-info.js triggers
  document.addEventListener('DOMContentLoaded', function() {
    // Set up a more specific observer for the price container
    const priceContainer = document.querySelector('.price__container');
    if (priceContainer) {
      const priceObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            // Check if any price elements were added or removed
            const hasPriceChanges = Array.from(mutation.addedNodes).some(node => 
              node.nodeType === Node.ELEMENT_NODE && 
              (node.classList.contains('price-item') || node.querySelector('.price-item'))
            ) || Array.from(mutation.removedNodes).some(node => 
              node.nodeType === Node.ELEMENT_NODE && 
              (node.classList.contains('price-item') || node.querySelector('.price-item'))
            );
            
            if (hasPriceChanges) {
              updateAffirmPrice();
            }
          }
        });
      });

      priceObserver.observe(priceContainer, {
        childList: true,
        subtree: true
      });
    }
  });

  // Also listen for URL changes (in case of variant selection via URL)
  let currentUrl = window.location.href;
  const urlObserver = new MutationObserver(function() {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      updateAffirmPrice();
    }
  });

  urlObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 